// Keep the home institution object intact for profile and registration forms.
export function personAffiliations(person) {
  if (!person) return ''
  if (typeof person.display_institution_names === 'string') return person.display_institution_names
  return (person.home_institution && person.home_institution.name) || (person.person_institution && person.person_institution.institution_name) || person.institution || ''
}
